import React from 'react';
import { urgency } from '../data/masterclass';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-132" data-mp="2bvcx0m9yiynu">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-133" data-mp="1wz5cfkumzv81">
        <h2 id="urgency-heading" className="max-w-3xl font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-134" data-mp="21xglvuh0s3pq">
          Don’t wait for the crack.{' '}
          <span className="text-gold" data-id="element-135" data-mp="1sylfaha2crlw">Check the foundation.</span>
        </h2>

        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/65" data-id="element-136" data-mp="1e9oxhsi7g083">
          {urgency.intro}
        </p>

        <ul className="mt-10 grid gap-x-12 border-y border-ink-line sm:grid-cols-2" data-id="element-137" data-mp="1j91uh62sinoe">
          {urgency.lines.map(line => <li key={line} className="border-b border-ink-line py-4 text-2xl text-white/75 last:border-b-0" data-id="element-138" data-mp="1590sfnasha7c">
              {line}
            </li>)}
        </ul>

        <p className="mt-8 font-display text-3xl font-semibold uppercase leading-snug text-white sm:text-4xl" data-id="element-139" data-mp="2613jc5jab52p">
          {urgency.close}
        </p>

        <p className="mt-6 max-w-3xl text-xl leading-relaxed text-white/70" data-id="element-140" data-mp="2fweygoylueaz">
          {urgency.final}
        </p>

        <div className="mt-12 border-t border-gold/20 pt-10" data-id="element-141" data-mp="2azogtx75jang">
          <Countdown data-id="element-142" data-mp="1n89cjyvtej9k" />
        </div>
      </div>
    </section>;
}